@if (alerts.length) {
  @for (alert of alerts; track alert) {
    <div [class]="'app-alert ' + alert.type">
      {{ alert.message | translate }}

      <button
        app-button
        class="app-alert__close"
        variant="base"
        [disableFocusStyles]="true"
        [onlyIcon]="true"
        (click)="remove(alert, $event, true)"
      >
        <app-svg-icon
          buttonIcon
          name="cancel"
        />
      </button>
    </div>
  }
}
